import { getApi, postApi, putApi, deleteApi } from './Api';

export const getWoundList = async () => {
  const url = `/wound/woundTypeList`;
  try {
    const response = await getApi(url);
    return response;
  } catch (e) {
    console.log('Error => ', e);
    throw e;
  }
};

export const getWoundDetail = async (id) => {
  const url = `/wound/woundTypeList/${id}`;
  try {
    const response = await getApi(url);
    return response;
  } catch (e) {
    console.log('Error => ', e);
    throw e;
  }
};

export const saveWound = async (data) => {
  const url = `/wound/woundTypeList`;
  try {
    const response = await postApi(url, data);
    return response;
  } catch (e) {
    console.log('Error => ', e);
    throw e;
  }
};

export const dupleWoundName = async (woundName) => {
  const url = `/wound/woundTypeListName?name=${woundName}`;
  try {
    const response = await getApi(url);
    return response;
  } catch (e) {
    console.log('Error => ', e);
    throw e;
  }
};

export const updateWound = async (id, data) => {
  const url = `/wound/woundTypeList/${id}`;
  try {
    const response = await putApi(url, data);
    return response;
  } catch (e) {
    console.log('Error => ', e);
    throw e;
  }
};

export const deleteWound = async (id) => {
  const url = `/wound/woundTypeList/${id}`;
  try {
    const response = await deleteApi(url);
    return response;
  } catch (e) {
    console.log('Error => ', e);
    throw e;
  }
};
